import FBody from '@/plugins/form/FBody';
import FNumber from '@/plugins/form/FNumber';

export default class DictionaryForm extends FBody {
  dictionary = '';

  id = new FNumber({
    show: false,
  });

  constructor(options) {
    super(options);
    this.setItem('id', this.id);
  }

  submit() {
    return super.submit()
      .then(() => this.api.dictionary.set({
        name: this.dictionary,
        model: this.data,
      }))
      .then(data => ({
        ...data.item,
        value: data.item.id,
        label: data.item.name,
      }));
  }
}
